<template>
      <el-drawer 
            style="background-color:#FFFFFF;"
            size="40%"
            title="我是标题"
            v-model="drawer"
            :with-header="false">
            <MenuBar/>
         </el-drawer>
        <img src="./assets/bang.png" v-if="isshow" @click="drawer = true" style="margin-left: 16px;position:absolute;right:1rem;top:1rem;z-index:1;width:5rem;height:2.3rem" alt="" >
  <keep-alive>
    <router-view>
    </router-view>
  
  </keep-alive>

</template>

<script>

import MenuBar from '@/components/MenuBar.vue'


export default {
  name: 'App',
  components:{
    MenuBar
  },
  data() {
    return {
      drawer:false,
    }
  }
}
</script>

<script setup>
import { watch,ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

var isshow = ref(true);
// 监听路由路径变化

watch(
  () => route.path,
  (newPath, oldPath) => {
    if(newPath=='/details'||newPath=='/opponent'||newPath=='/echartpage'||newPath=='/matchpage'){
      isshow.value = false
    }else{
      isshow.value = true
    }
  }
);

</script>

<style lang="less" src="./assets/style/reset.less"></style>
